var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"task-status-button",class:['task-status-button--' + _vm.value]},'div',_vm.$attrs,false),[_c('div',{staticClass:"task-status-button__dot"}),_c('div',{staticClass:"task-status-button__label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }